// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"15046e62517023ab5e66","883":"fe5c57a350b82e8a4a59"}[chunkId] + ".js";
};